var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c(
      "div",
      { staticClass: "trbo-a-layout__wrapper" },
      [
        _c(
          "div",
          { staticClass: "trbo-a-layout__header" },
          [
            _c("question-header", {
              attrs: { settings: _vm.settings.header },
              on: {
                restart: _vm.onRestart,
                "go-to-landing-page": _vm.onGoToLandingPage,
                "progress-bar-item-click": _vm.onProgressBarItemClick,
                search: _vm.onSearch,
                "link-from-message-click": _vm.onClickLinkFromMessage,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "trbo-a-layout__content" },
          [_vm._t("default")],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.footerClasses },
          [
            _c("page-footer", {
              on: {
                prev: _vm.onPrev,
                next: _vm.onNext,
                skip: _vm.onSkip,
                "load-more-products": _vm.onLoadMoreProducts,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasNotification
          ? _c("notification", {
              attrs: {
                type: _vm.notification.type,
                message: _vm.notification.message,
              },
              on: { close: _vm.clearNotification },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }